import { render, staticRenderFns } from "./EnvironmentForm.vue?vue&type=template&id=e4098c22"
import script from "./EnvironmentForm.vue?vue&type=script&lang=js"
export * from "./EnvironmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports